// Port of api/fuel/app/classes/filter/search/games/filters/query/other/tags.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'

var TAG_CONTEXT_GAME = 0
var TAG_CONTEXT_COLLECTION = 1
var TAG_CONTEXT_RATING = 2
var TAG_CONTEXT_PLAY = 3

export default {
	name: 'other.tags',
	priority: 76,
	_owner_exclude: [F.OWNER_GROUP, F.OWNER_BUDDIES],
	require: function(config, filter) {
		return filter.tags && filter.tags.length > 0
	},
	run: function(config, filter, data, query) {
		var tagIds = Util.abs(filter.tags)
		if (!tagIds.length) return

		// Determine visibility: own tags always visible, public tags for others
		var publicVals = [1]
		if (config.sessionID === config.owner.get_id()) publicVals.push(0)

		// Context: game tags always, plus result-type-specific
		var contexts = [TAG_CONTEXT_GAME]
		if (config.resultType === F.RESULT_COLLECTION) contexts.push(TAG_CONTEXT_COLLECTION)
		if (config.resultType === F.RESULT_RATING) contexts.push(TAG_CONTEXT_RATING)
		if (config.resultType === F.RESULT_PLAY) contexts.push(TAG_CONTEXT_PLAY)

		// Validate tags belong to owner with correct visibility and context
		var validTags = DB.query(
			'SELECT tag_id FROM tag WHERE user_id = ' + config.owner.get_id() +
			' AND tag_id IN(' + Util.in(tagIds) + ')' +
			' AND tag_public IN(' + publicVals.join(',') + ')' +
			' AND tag_context IN(' + contexts.join(',') + ')'
		)
		var validTagIds = Util.pluck(validTags, 'tag_id')
		if (!validTagIds.length) return

		// Get tag attachments
		var attaches = DB.query('SELECT tag_id, game_id, collection_id, rating_id, play_id FROM tag_attach WHERE tag_id IN(' + Util.in(validTagIds) + ')')

		var require = [], include = [], exclude = []
		for (var i = 0; i < filter.tags.length; i++) {
			var v = filter.tags[i]
			var absV = Math.abs(v)
			if (validTagIds.indexOf(absV) === -1 && validTagIds.indexOf(String(absV)) === -1) continue
			if (v < 0) exclude.push(absV)
			else include.push(absV)
		}
		// Plain IDs (no +/- prefix) go to require (AND logic) — same as PHP Util::positive($tags, true)
		// For simplicity, treat all include IDs as require (must have ALL)
		var gameInclude = [], gameExclude = []

		for (var a = 0; a < attaches.length; a++) {
			var att = attaches[a]
			var gid = Number(att.game_id)
			if (!gid) continue
			var tid = Number(att.tag_id)
			if (include.indexOf(tid) !== -1 || include.indexOf(String(tid)) !== -1) gameInclude.push(gid)
			if (exclude.indexOf(tid) !== -1 || exclude.indexOf(String(tid)) !== -1) gameExclude.push(gid)
		}

		if (include.length) {
			if (gameInclude.length) query.where('g.game_id', 'in', gameInclude)
			else query.where('g.game_id', '=', 0)
		}
		if (exclude.length && gameExclude.length) {
			query.where('g.game_id', 'not in', gameExclude)
		}
	}
}
